import { getImageSearchFilters } from 'js/sagas/selectors';
import { useAppSelector } from 'js/store/hooks';

export default function useSearchFilters() {
  const submittedSearchInput = useAppSelector(state => state.imageSearch.submittedSearchInput || '');
  const loading = useAppSelector(
    state => state.imageDrawer.imageLibrary.search.videoscribe[submittedSearchInput]?.loading
  );
  const { filters } = useAppSelector(getImageSearchFilters);

  const selectedCount = filters.reduce((acc, filter) => {
    const selected = filter.values.filter(val => val.selected);
    return acc + selected.length;
  }, 0);

  return {
    filters,
    selectedCount,
    loading
  };
}
